import React from "react";
import parse from 'html-react-parser';
import { FontSize, Text } from 'src/components';
import { i18n } from "src/common";
import { colors } from "src/theme";

export interface HtmlTextProps {
  text?: string;
  i18nKey?: string;
  links?: Array<HtmlTextLink>;
  textType?: FontSize;
}

export interface HtmlTextLink {
  value: string;
  link: string;
  translation: string;
}

export const HtmlText = ({ text = '', i18nKey, links, textType = "small" }: HtmlTextProps) => {

  const displayText = i18nKey && !links ? i18n.t(i18nKey) : text;

  const createTextWithLinks = (translationKey: string, footerLinks: Array<HtmlTextLink>) => {
    let inputString = i18n.t(translationKey);
    footerLinks.forEach(fl => {
      inputString = inputString.replace(`{${fl.value}}`, `<a style="color: ${colors.primary}" href="${fl.link}" target="_blank" rel="noreferrer">${fl.translation}</a>`);
    });

    return parse(inputString);
  }

  return (
    <Text type={textType}>{i18nKey && links?.length ? createTextWithLinks(i18nKey, links) : displayText}</Text>
  )
};
